"use client";

import dynamic from "next/dynamic";

const CartSidebar = dynamic(() => import("@/components/cart/CartSidebar"), { ssr: false });

export default function LazyCartSidebar(props: React.ComponentProps<typeof CartSidebar>) {
  return <CartSidebar {...props} />;
}
